import { popUp } from "../../controls/popUp";
import { ll } from "../../core/ll";
import { ComponentOptions } from "./component";
import { Pane } from "./pane";
import { UserComponent } from "./userComponent";

export abstract class PopUp extends UserComponent {

    protected view: Pane;
    protected popUpArgs: any;
    private popUpInstance: any;

    constructor(viewFactory: () => Pane, options: ComponentOptions) {
        super(viewFactory, options);
    }

    get window(): kendo.ui.Window {
        return this.popUpInstance.window;
    }

    popUp(args): void {
        // Alter the layout of the pane to show the buttons along the bottom.
        this.view.options.isPopUpChild = true;

        // Remove container classes from the pane's components.
        if (this.view.content.components) {
            $.each(this.view.content.components, function (index, component) {
                component && component.options && (component.options.containerClasses = null);
            });
        }

        var popUpArgs = this.popUpArgs || {};
        $.extend(popUpArgs, {
            id: "PopUp",
            title: ll(this.view.options.header),
            removeButtons: true,
            close: function () {
                args.cancel && args.cancel();
            }
        });

        this.popUpInstance = popUp(popUpArgs);
        this.render(this.popUpInstance.guts);
        this.window.title(ll(this.view.options.header));

        this.bindEvents();
        this.initialize(args);
    }

    closePopUp() {
        this.window.close();
    }

    abstract bindEvents(): void;

    abstract initialize(args: any): void;

}
